<script setup>
import CheckBox from "@/components/ai-onboarding/partials/CheckBox.vue";

const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  checked: {
    type: Boolean,
    required: true,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  tooltipText: {
    type: String,
    required: false,
    default: '',
  },
});

const emit = defineEmits(['update:checked']);

const handleClick = () => {
  if (props.disabled) {
    return;
  }

  emit('update:checked', !props.checked);
};

</script>

<template>
  <VTooltip
    placement="bottom"
    theme="dark-blue-tooltip"
    :disabled="!disabled && !!tooltipText"
  >
    <div
      :class="[
        'tw-flex tw-w-full tw-justify-between tw-items-center flex-shrink-0 tw-p-8 tw-h-22 tw-rounded-3xl tw-cursor-pointer tw-gap-6',
        'tw-bg-gradient-to-b tw-from-blueGradientStart tw-to-blueGradientEnd',
        { 'tw-outline tw-outline-2 tw-outline-blue': checked },
        { '!tw-cursor-not-allowed': disabled },
      ]"
      @click="handleClick"
    >
      <div class="tw-flex tw-justify-between tw-items-center tw-min-w-0">
        <span class="tw-text-grey-dark tw-text-2.5xl tw-font-bold tw-truncate">
          {{ text }}
        </span>
      </div>

      <CheckBox
        class="tw-flex-shrink-0"
        :model-value="checked"
        @update:model-value="handleClick"
      />
    </div>
    <template #popper>
      {{ tooltipText }}
    </template>
  </VTooltip>
</template>
